import moment from "moment";
import React, { useEffect, useState } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { usePyamentsDashboardTable } from "./store";
import Loader from "modules/Loader";
import { Checkbox, Select, Table } from "antd/lib";

const { Option } = Select;

function ReasonFailedTransactions() {
  const [startDate, setStartDate] = useState(new Date());
  const [selectedFilters, setSelectedFilters] = useState([]);
  const { fetchPaymentsDashboardTable, pyamentsDashboardTableData, isLoading } =
    usePyamentsDashboardTable();

  const handleDateChange = (date) => {
    const startOfDay = moment(date).startOf("day").toDate();
    setStartDate(startOfDay);
  };

  useEffect(() => {
    if (startDate) {
      const startOfDate = moment(startDate)
        .subtract("1", "D")
        .startOf("D")
        .toISOString();
      const endOfDate = moment(startDate)
        .subtract("1", "D")
        .endOf("D")
        .toISOString();
      const payload = {
        startDate: startOfDate,
        endDate: endOfDate,
        type: "table",
      };
      fetchPaymentsDashboardTable(payload);
    }
  }, []);

  const handleSubmit = () => {
    const startOfDate = moment(startDate).startOf("D").toISOString();
    const endOfDate = moment(startDate).endOf("D").toISOString();
    const payload = {
      startDate: startOfDate,
      endDate: endOfDate,
      type: "table",
    };
    fetchPaymentsDashboardTable(payload);
  };

  const dataForFilters = pyamentsDashboardTableData.reduce((acc, item) => {
    const firstValue = item[0].split("|")[0];

    if (!acc[firstValue]) {
      acc[firstValue] = 1;
    } else {
      acc[firstValue]++;
    }

    return acc;
  }, {});

  const columns = [
    {
      title: "Reasons",
      dataIndex: 0,
      key: "reasons",
      filters: Object.keys(dataForFilters).map((filter) => ({
        text: `${filter} (${dataForFilters[filter]})`,
        value: filter,
      })),
      onFilter: (value, record) => record[0].includes(value),
    },
    {
      title: "Payment Gateway",
      dataIndex: 1,
      key: "paymentGateway",
      
    },
    {
      title: "No. of Transaction",
      dataIndex: 2,
      key: "numTransactions",
      sorter: (a, b) => parseFloat(a[2]) - parseFloat(b[2]),
      
    },
    {
      title: "No. of Order",
      dataIndex: 3,
      key: "numOrders",
    },
    {
      title: "No. of Cases Abandoned",
      dataIndex: 4,
      key: "numCasesAbandoned",
    },
  ];


  return (
    <div>
      <>
        <div className="d-flex gap-2 mb-2" style={{ width: "30rem" }}>
          <DatePicker
            selected={startDate}
            onChange={handleDateChange}
            formatWeekDay={(day) => day.slice(0, 3)}
            className="form-control"
            placeholderText="Select Date"
          />
          <button className="btn btn-primary" onClick={handleSubmit}>
            Submit
          </button>
        </div>
        <Table
          dataSource={pyamentsDashboardTableData.map((row, index) => ({
            key: index,
            ...row,
          }))}
          columns={columns}
        />
      </>
    </div>
  );
}

export default ReasonFailedTransactions;
